import React, { useState } from "react";
import { Logo1, Logo2, MOPLogo } from "../../Assets";
import { NavLink, useNavigate } from "react-router-dom";
import { Modal, message } from "antd";

const Sidebar = () => {
  const [Modalbox, setModalbox] = useState(false);
  const Navigate = useNavigate();

  // Get logged-in user's college ID
  const collegeId = localStorage.getItem("SDG_COLLEGE_ID");

  // M.O.P. Vaishnav College for Women
  const isMOP = String(collegeId) === "1";

  return (
    <div
      className={`w-full h-full bg-[#c7ecff] flex flex-col justify-between shadow-lg shadow-Navy`}
    >
      <div>
        {/* =====================================================
            LOGO
        ===================================================== */}
        <div className={`flex flex-col items-center`}>
          {isMOP ? (
          <img
            src={MOPLogo}
            alt="M.O.P. Vaishnav College for Women"
            className="w-[220px] my-4"
          />
        ) : (
          <>
            <img
              src={Logo1}
              alt="Csim Logo"
              className="w-[80px] my-4"
            />

            <img
              src={Logo2}
              alt="Csim Logo"
              className="w-[100px]"
            />
          </>
        )}
        </div>

        {/* =====================================================
            MENU
        ===================================================== */}
        <div className={`flex flex-col`}>

          {/* DASHBOARD */}
          <NavLink
            to={`/`}
            className={({ isActive }) =>
              isActive
                ? `bg-Navy text-white py-2 px-2 font-semibold border-b-[1px]`
                : `bg- text-Navy py-2 px-2 font-semibold`
            }
          >
            <i className="fa-solid fa-chart-pie"></i>{" "}
            Dashboard
          </NavLink>

          {/* =================================================
              MANAGE COLLEGE

              Hide this menu for M.O.P. users.
              Normal users will still see it.
          ================================================= */}
          {!isMOP && (
            <NavLink
              to={`/college`}
              className={({ isActive }) =>
                isActive
                  ? `bg-Navy text-white py-2 px-2 font-semibold border-b-[1px]`
                  : `bg- text-Navy py-2 px-2 font-semibold border-b-[1px]`
              }
            >
              <i className="fa-solid fa-building-columns"></i>{" "}
              Manage college
            </NavLink>
          )}

        </div>
      </div>

      {/* =====================================================
          LOGOUT
      ===================================================== */}
      <div className="my-2">
        <button
          className="py-2 text-Navy text-center font-semibold w-full"
          onClick={() => setModalbox(true)}
        >
          <i className="fa-solid fa-right-from-bracket"></i>{" "}
          Logout
        </button>
      </div>

      {/* =====================================================
          LOGOUT CONFIRMATION
      ===================================================== */}
      <Modal
        title="Are you sure want to logout?"
        open={Modalbox}
        centered
        okType="danger"
        onOk={() => {
          localStorage.removeItem("SDG_TOKEN");
          localStorage.removeItem("SDG_COLLEGE_ID");

          Navigate("/login", { replace: true });

          message.success({
            type: "success",
            content: `Logout successfully`,
          });
        }}
        onCancel={() => {
          setModalbox(false);
        }}
      ></Modal>
    </div>
  );
};

export default Sidebar;